import { Quote } from "lucide-react";

export default function Testimonial() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <Quote className="w-16 h-16 text-orange-500 mx-auto mb-6" />
          <blockquote className="text-2xl md:text-3xl text-gray-600 italic leading-relaxed mb-8">
            "At the core of our practice is the idea that cities are the
            incubators of our greatest achievements, and the best hope for a
            sustainable future."
          </blockquote>
          <div className="border-t-2 border-orange-500 w-24 mx-auto mb-4"></div>
          <div className="text-gray-900 font-bold text-lg">JESSE DEGLORY</div>
          <div className="text-gray-500 text-sm">DIRECTOR</div>

          <div className="flex justify-center items-center space-x-2 mt-8">
            {[0, 1, 2, 3, 4].map((i) => (
              <div
                key={i}
                className={`w-2.5 h-2.5 rounded-full transition-all ${
                  i === 0
                    ? "bg-orange-500 w-3 h-3"
                    : "bg-gray-300 hover:bg-orange-300"
                }`}
              ></div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
